require('./mortgageRequestAmountCostEstates.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestExpensesItemList = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestExpensesItemList');

// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @ constants
const { currencyExpensesParams } = require('constants/mortgageRequestCurrencyFormats');


class MortgageRequestAmountCostEstates extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isExpanded: false,
            id: 'amountcoststates'
        };
    }

    buildAccordion(importeCompraVentaParams, totalmortgagedProperties, totalNoMortagagedProperties) {
        const expensesItemClasses = {
            item: ['mortgage-request-amount-cost-estates__item', 'row'],
            title: ['mortgage-request-amount-cost-estates__title', 'col-xs-9'],
            value: ['mortgage-request-amount-cost-estates__value', 'col-xs-3'],
            list: ['mortgage-request-amount-cost-estates', 'list-unstyled'],
        };

        const itemList = [
            {
                text: 'mortgageRequestAmountCostEstates-mortgageRequestAmountCostEstates_totalMortgagedProperties',
                value: totalmortgagedProperties
            },
            {
                text: 'mortgageRequestAmountCostEstates-mortgageRequestAmountCostEstates_totalNoMortgagedProperties',
                value: totalNoMortagagedProperties
            },
        ];

        const rightContentTotal = (
            <div className="mortgage-request-amount-cost-estates__amount">
                {importeCompraVentaParams}
            </div>
        );

        return (
            <Accordion
                customClassName="mortgage-request-amount-cost-estates"
                isExpanded={this.state.isExpanded}
                id={this.state.id}
            >
                <AccordionHeader name="AccordionHeader" iconStyle isMiddleArrowPosition rightContent={rightContentTotal}>
                    <div className="mortgage-request-amount-cost-estates__header row no-outside-gutter">
                        <FormattedText value="mortgageRequestExpensesAmmount-tradingText" />
                    </div>
                </AccordionHeader>

                <AccordionBody name="AccordionBody">
                    <MortgageRequestExpensesItemList
                        expensesItemClasses={expensesItemClasses}
                        itemsList={itemList}
                    />

                </AccordionBody>
            </Accordion>
        );
    }

    buildSingleItem(importeCompraVenta) {
        const itemList = [
            {
                text: 'mortgageRequestExpensesAmmount-tradingText',
                value: importeCompraVenta
            }
        ];
        const expensesSingleItemClasses = {
            item: ['mortgage-request-amount-cost-estates__single-item', 'row'],
            title: ['mortgage-request-amount-cost-estates__single-item__title', 'col-xs-9'],
            value: ['mortgage-request-amount-cost-estates__single-item__value', 'col-xs-3'],
            list: ['mortgage-request-amount-cost-estates', 'list-unstyled'],
        };

        return (
            <MortgageRequestExpensesItemList
                expensesItemClasses={expensesSingleItemClasses}
                itemsList={itemList}
            />
        );
    }

    render() {
        const { importeCompraVenta, totalmortgagedProperties, totalNoMortagagedProperties } = this.props;
        const importeCompraVentaParams = MortgageRequestCurrencyHelp(currencyExpensesParams(importeCompraVenta));

        const renderData = !!totalNoMortagagedProperties
            ? this.buildAccordion(importeCompraVentaParams, totalmortgagedProperties, totalNoMortagagedProperties)
            : this.buildSingleItem(importeCompraVentaParams);

        return (
            <div>
                {renderData}
            </div>
        );
    }
}

MortgageRequestAmountCostEstates.propTypes = {
    importeCompraVenta: PropTypes.number.isRequired,
    totalmortgagedProperties: PropTypes.number.isRequired,
    totalNoMortagagedProperties: PropTypes.number.isRequired,
};


module.exports = MortgageRequestAmountCostEstates;
